/* eAuto Search Analytics ‚Äî storefront emitter (theme asset)
 *
 * Decoupled from eauto-search.js: it listens for two CustomEvents and batches
 * them to the app proxy via navigator.sendBeacon. No PII; anonymous session id.
 *
 * eauto-search.js dispatches:
 *   document.dispatchEvent(new CustomEvent('eauto:search', { detail: {
 *     raw_query, norm_query, corrected_from, corrected_to,
 *     vehicle_brand, vehicle_model, result_count, zero_result, fallback_path } }))
 *   document.dispatchEvent(new CustomEvent('eauto:searchclick', { detail: {
 *     raw_query, vehicle_brand, vehicle_model, action, action_target } }))
 *
 * Install: add this file as assets/eauto-search-analytics.js and load it AFTER
 * eauto-search.js:  <script src="{{ 'eauto-search-analytics.js' | asset_url }}" defer></script>
 */
(function () {
  'use strict';
  var ENDPOINT = '/apps/search-analytics/collect';
  var FLUSH_MS = 4000;     // periodic flush
  var MAX_BATCH = 20;      // flush early when this many queued
  var queue = [];
  var timer = null;

  // --- consent: stay silent if the shopper declined analytics ---------------
  function analyticsAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
        return cp.analyticsProcessingAllowed();
      }
    } catch (e) {}
    return true; // default allow when consent API isn't present
  }

  function sessionId() {
    try {
      var k = 'eauto.sa.sid';
      var v = sessionStorage.getItem(k);
      if (!v) {
        v = (Date.now().toString(36) + Math.random().toString(36).slice(2, 10));
        sessionStorage.setItem(k, v);
      }
      return v;
    } catch (e) { return null; }
  }

  function device() {
    try { return window.matchMedia('(max-width: 768px)').matches ? 'mobile' : 'desktop'; }
    catch (e) { return 'desktop'; }
  }

  function enqueue(ev) {
    if (!analyticsAllowed()) return;
    ev.ts = Date.now();
    ev.session = sessionId();
    ev.device = device();
    queue.push(ev);
    if (queue.length >= MAX_BATCH) flush();
    else if (!timer) timer = setTimeout(flush, FLUSH_MS);
  }

  function flush() {
    if (timer) { clearTimeout(timer); timer = null; }
    if (!queue.length) return;
    var batch = queue.splice(0, queue.length);
    var payload = JSON.stringify({ events: batch });
    var sent = false;
    try {
      if (navigator.sendBeacon) {
        sent = navigator.sendBeacon(ENDPOINT, new Blob([payload], { type: 'application/json' }));
      }
    } catch (e) {}
    if (!sent) {
      try {
        fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: payload, keepalive: true });
      } catch (e) {}
    }
  }

  // Flush on tab hide / unload so we don't lose the last events.
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flush(); });
  window.addEventListener('pagehide', flush);

  // --- listen to the search's custom events ---------------------------------
  document.addEventListener('eauto:search', function (e) {
    var d = e.detail || {};
    if (!d.raw_query) return;
    enqueue({
      raw_query: d.raw_query, norm_query: d.norm_query || null,
      corrected_from: d.corrected_from || null, corrected_to: d.corrected_to || null,
      vehicle_brand: d.vehicle_brand || null, vehicle_model: d.vehicle_model || null,
      result_count: (typeof d.result_count === 'number') ? d.result_count : null,
      zero_result: d.zero_result ? 1 : 0,
      fallback_path: d.fallback_path || 'primary',
      action: 'submit', action_target: null
    });
  });

  document.addEventListener('eauto:searchclick', function (e) {
    var d = e.detail || {};
    enqueue({
      raw_query: d.raw_query || '', norm_query: d.norm_query || null,
      vehicle_brand: d.vehicle_brand || null, vehicle_model: d.vehicle_model || null,
      result_count: null, zero_result: 0, fallback_path: null,
      action: d.action || 'click_product', action_target: d.action_target || null
    });
    flush(); // clicks usually precede a navigation ‚Äî send promptly
  });
})();
